import { render, staticRenderFns } from "./ContactsRegistrationForm.vue?vue&type=template&id=a5e4d050&scoped=true"
import script from "./ContactsRegistrationForm.vue?vue&type=script&lang=js"
export * from "./ContactsRegistrationForm.vue?vue&type=script&lang=js"
import style0 from "./ContactsRegistrationForm.vue?vue&type=style&index=0&id=a5e4d050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e4d050",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VContainer,VForm,VRow,VSelect})
